<template>
    <v-dialog v-model="showModal" fullscreen :scrollable="isScrollable">
        <v-card light class="fill-height">
          <v-toolbar dark color="orange darken-3">
            <v-btn icon dark @click="close()">
              <v-icon large>mdi-arrow-left-circle</v-icon>
            </v-btn>
            <v-toolbar-title class="display-1">Check-out</v-toolbar-title>
          </v-toolbar>
            <v-stepper v-model="curr" color="green">
                <v-stepper-content v-for="(step,n) in steps" :step="n+1" :key="n">
                    {{ step.name }}
                    <v-component v-if="step.valid" v-bind:is="step.component"
                      @stepSuccess="continueToNext(n)"
                    />
                </v-stepper-content>
            </v-stepper>
        </v-card>
    </v-dialog>
</template>

<script>
import Checkout from './Checkout.vue'
import FinalPage from '../FinalPage.vue'

export default {
  name: 'CheckoutIndex',
  data: () => ({
    curr: 1,
    steps: [
      { name: '', component: Checkout, valid: true, scrollable: true },
      { name: '', component: FinalPage, valid: false, scrollable: false }
    ],
    valid: false,
    stepForm: [],
    showModal: true
  }),

  created () {
    this.$store.dispatch('decision/onProcessDecision', 'checkout')
  },

  computed: {
    isScrollable () {
      return this.steps[this.curr - 1].scrollable
    },
    lastStep () {
      return this.steps.length
    }
  },

  methods: {
    close () {
      this.showModal = false
      this.$router.push({ name: 'HomePage' })
    },
    stepComplete (step) {
      return this.curr > step
    },
    stepStatus (step) {
      return this.curr > step ? 'green' : 'orange darken-3'
    },
    continueToNext (n) {
      this.steps[n].valid = false
      this.steps[n + 1].valid = true
      this.curr += 1
    },
    done () {
      this.curr = this.lastStep
    }
  }
}
</script>
